module.exports = __webpack_public_path__ + "img/icon_patent_en.b5e9c1ff.png";